import React, { useState, useEffect, useContext } from 'react';
import './OrientationOverlay.scss';
import { I18nReactContext } from '../../../../contexts/I18nContext';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';

export const OrientationOverlay = ({ isActive }) => {
    const { i18n } = useContext(I18nReactContext);

    if (!isActive) return null;

    return (
        <div className="OrientationOverlay">
            <div className="overlay-content">
                <ScreenRotationIcon className="rotate-icon" />
                <h2>{i18n.translate('weezbeeCourse.orientationOverlay.title')}</h2>
                <p>{i18n.translate('weezbeeCourse.orientationOverlay.message')}</p>
            </div>
        </div>
    );
};
